import React, { useEffect, useRef } from "react";

export default function PluginLoader({ manifest, propsFromHost = {}, objectData}) {
  const ref = useRef(null);
  const loadedRef = useRef(false);


  useEffect(() => {
    if (!manifest || !manifest.entry) return;

    const globalFn = manifest.globalRenderName || "renderMyPlugin";
    const unmountFn = manifest.unmountName || "unmountMyPlugin";

    // 🔥 HARDCODED CONTEXT FOR TESTING
    const platformContext = {
      ...propsFromHost, // allow override if passed later
      ...objectData, // allow override if passed later
    };

    const mountPlugin = () => {
      if (!window[globalFn] || !ref.current) return;
      try {
        window[globalFn](ref.current, {
          manifest,
          platformContext,   // ✅ sent to plugin
        });
      } catch (e) {
        console.error("Plugin mount error:", e);
      }
    };

    if (window[globalFn] && !loadedRef.current) {
      loadedRef.current = true;
      mountPlugin();
    } else {
      const script = document.createElement("script");
      script.src = manifest.entry;
      script.async = true;

      script.onload = () => {
        loadedRef.current = true;
        mountPlugin();
      };

      document.body.appendChild(script);
    }

    return () => {
      const node = ref.current;
      if (!node) return;

      if (window[unmountFn]) {
        try {
          window[unmountFn](node);
        } catch (e) {
          console.warn("Plugin unmount safe error ignored:", e);
        }
      }
    };
  }, [manifest]);

  return <div ref={ref} style={{ minHeight: "20px", minWidth: "20px" }} />;
}